import { MlSpaceCardProps } from './index'

export enum MlSpaceCardSkeletonVariant {
  CAROUSEL = 'carousel',
  GRID = 'grid',
}

type MlSpaceCardSkeletonProps = Pick<MlSpaceCardProps, 'size'> & { variant?: MlSpaceCardSkeletonVariant }

export const MlSpaceCardSkeleton = ({ size, variant = MlSpaceCardSkeletonVariant.GRID }: MlSpaceCardSkeletonProps) => {
  if (variant === MlSpaceCardSkeletonVariant.CAROUSEL) {
    return <MlSpaceCardSkeletonCarousel size={size} />
  }

  return <MlSpaceCardSkeletonGrid size={size} />
}

const MlSpaceCardSkeletonGrid = ({ size = 'small' }: Omit<MlSpaceCardSkeletonProps, 'variant'>) => (
  <div
    aria-hidden
    className={`animate-pulse-fast ${
      size === 'small'
        ? 'w-[15.875rem]'
        : 'w-[20.375rem] sm:w-[20.813rem] ml-[1.25rem] mt-[1.563rem] mr-[0.7rem] sm:mt-[1.563rem] slg:w-[13rem] slg:mr-[1.25rem] slg:ml-2  lg:w-[15.401rem] lg:ml-[0.938rem] lg:mt-[3.688rem]'
    }`}
  >
    <div className="mb-4 bg-neutrals-300 opacity-4 rounded-4 aspect-[4/3]" />
    <div className={`mb-2 bg-neutrals-300 opacity-[0.6] h-8 ${size === 'small' ? 'mr-2.5' : 'w-full'}`} />
    <div className={`mb-4 bg-neutrals-300 opacity-[0.4] h-5 ${size === 'small' ? 'mr-[3.75rem]' : 'mr-[5.3125rem]'}`} />
    <div className={`mb-2 bg-neutrals-300 opacity-[0.3] h-10 ${size === 'small' ? 'mr-9' : 'mr-12'}`} />
    <div className={`mb-4 bg-neutrals-300 opacity-[0.2] h-10 ${size === 'small' ? 'mr-9' : 'mr-12'}`} />
    <div className={`bg-neutrals-300 opacity-[0.1] h-7 ${size === 'small' ? 'w-[6.25rem]' : 'w-32'}`} />
  </div>
)

const MlSpaceCardSkeletonCarousel = ({ size = 'small' }: Omit<MlSpaceCardSkeletonProps, 'variant'>) => (
  <div
    aria-hidden
    className={`animate-pulse-fast border-1 border-[#00000000] ${
      size === 'small' ? 'w-[17.88rem]' : 'w-[22.425rem] slg:w-[14.219rem] lg:w-[17.579125rem]'
    }`}
  >
    <div className="p-2 lg:p-4">
      {/* Image */}
      <div className="mb-2 lg:mb-4 bg-neutrals-300 opacity-4 rounded-4 aspect-[4/3]" />
      {/* Title */}
      <div className={`mb-1 bg-neutrals-300 opacity-[0.6] h-7 ${size === 'small' ? 'mr-2.5' : 'w-full'}`} />
      {/* Subtitle */}
      <div
        className={`mb-2 bg-neutrals-300 opacity-[0.4] h-[1.313rem] ${
          size === 'small' ? 'mr-[3.75rem]' : 'mr-[5.3125rem]'
        }`}
      />
      {/* 1st feature */}
      <div className={`bg-neutrals-300 opacity-[0.3] h-10 ${size === 'small' ? 'mr-9' : 'mr-12'}`} />
      {/* 2nd feature */}
      <div className={`mb-2 bg-neutrals-300 opacity-[0.3] h-10 ${size === 'small' ? 'mr-9' : 'mr-12'}`} />
      {/* Rate */}
      <div className={`bg-neutrals-300 opacity-[0.1] h-[1.625rem] ${size === 'small' ? 'w-[6.25rem]' : 'w-32'}`} />
    </div>
  </div>
)
